import React, { useState, useRef, useEffect } from "react";
import ProgressBar from "../ProgressBar/ProgressBar";
import "./mobilenumber.css";
import MobileNumber from "../../assets/icons/MobileNumber.svg";
import BottomButtons from "../bottom-buttons/BottomButtons";
import { candidateDetailSuccess } from "../../redux/actions";
import history from "../../routes/history";
import { useSelector, useDispatch } from "react-redux";
import { checkIsUniqueNumber } from "../../API/API";

const CandidateMobileNumber = () => {
  const [loading, setLoading] = useState(false);
  const [numberValidation, setNumberValidation] = useState("");
  const inputvalue = useRef(null);
  const getInputValues = useSelector(
    (state) => state.candidateReducer.candidateDetails
  );
  const [isActive, setIsActive] = useState(true);
  const dispatch = useDispatch();

  const clearValidation = () => {
    setNumberValidation("");
  };

  const formatPhoneNumber = (value) => {
    const cleaned = ("" + value).replace(/\D/g, "");
    const match = cleaned.match(/(\d{3})(\d{3})(\d{4})/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return value;
  };

  const nextHandler = async () => {
    try {
      setLoading(true);
      const numberValue = inputvalue.current.value.trim();
      const validFormat = /^\(\d{3}\) \d{3}-\d{4}$/;
      if (!numberValue || !validFormat.test(numberValue)) {
        setNumberValidation("Please enter a valid phone number.");
        return;
      }
      const plainNumber = numberValue.replace(/\D/g, "");
      const formattedNumber = `1${plainNumber}`;
      const isNewNumber = await checkIsUniqueNumber(`1${plainNumber}`);
      if (isNewNumber !== true) {
        setNumberValidation("Number already exists");
        return;
      }
      dispatch(
        candidateDetailSuccess({ ...getInputValues, mobileNo: formattedNumber })
      );
      history.push("/select-gig-type");
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const backHandler = () => {
    history.push("/add-candidate-name");
  };

  const handleInputChange = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    const formattedNumber = formatPhoneNumber(input);
    inputvalue.current.value = formattedNumber;
    clearValidation();
    setIsActive(false);
  };

  const handleClickOutside = (e) => {
    if (inputvalue.current && !inputvalue.current.contains(e.target)) {
      setIsActive(true);
    }
  };

  useEffect(() => {
    if (inputvalue.current) {
      inputvalue.current.focus();
      setIsActive(false);
    }
    if (getInputValues?.mobileNo) {
      const plainNumber = getInputValues?.mobileNo.slice(1);
      const formatted = formatPhoneNumber(plainNumber);
      inputvalue.current.value = formatted;
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [getInputValues?.mobileNo]);

  return (
    <div className="profilecompleteion">
      <div>
        <ProgressBar heading={"Create candidate’s profile"} percent={30} />
        <div className="email-text">
          Candidate’s mobile number
          <div className="email-mandatory">(Mandatory)</div>
        </div>
        <div className="mobilemain">
          <div className="Mobile-box">
            <img src={MobileNumber} alt="Mobile Icon" className="mobile-icon" />
            <div className="Number">+1</div>
          </div>

          <div className="mobilesub">
            <div
              className={
                numberValidation
                  ? "validation-err"
                  : `${isActive ? "inactive" : "email-inputs"}`
              }
            >
              <input
                placeholder="(000) 000-0000"
                type="tel"
                className={`candidate-inputs ${
                  numberValidation ? "" : isActive ? "inactive-input" : ""
                }`}
                ref={inputvalue}
                style={{ color: isActive ? "#5e5e5e" : "#1E1E1E" }}
                onChange={handleInputChange}
                defaultValue={
                  getInputValues?.mobileNo
                    ? formatPhoneNumber(getInputValues?.mobileNo.slice(1))
                    : ""
                }
                onClick={() => {
                  setIsActive(false);
                }}
              />
            </div>
            {numberValidation && (
              <div className="validation-num-message">{numberValidation}</div>
            )}
          </div>
        </div>
        <BottomButtons
          nextHandler={nextHandler}
          backHandler={backHandler}
          nextBtnLoading={loading}
        />
      </div>
    </div>
  );
};

export default CandidateMobileNumber;
